import React from "react";
import { pillarDot } from "@/lib/pillarApi";

export const PillarProgress = ({ pillars, state, testPrefix = "pillar-progress" }) => (
  <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
    {pillars.map((p) => {
      const prog = state?.pillar_progress?.[p.id] || { assessed: 0, last_week: 0, pct: 0 };
      return (
        <div key={p.id} data-testid={`${testPrefix}-${p.id}`} className="p-3 rounded-sm border border-white/10 bg-white/[0.02]">
          <div className="flex items-center gap-2">
            <span className="h-2.5 w-2.5 rounded-full shrink-0" style={{ background: pillarDot(p.color_hex) }} />
            <span className="text-[11px] text-nex-silver leading-tight line-clamp-2">{p.name}</span>
          </div>
          <div className="mt-2 font-mono text-lg text-nex-gold">{prog.assessed}<span className="text-nex-muted text-[10px]"> wks</span></div>
          <div className="mt-1 h-1 bg-white/5 rounded-full overflow-hidden">
            <div className="h-full bg-nex-gold" style={{ width: `${Math.min(prog.pct, 100)}%` }} />
          </div>
          <div className="mt-1 font-mono text-[9px] tracking-[0.18em] uppercase text-nex-muted">Last week {prog.last_week || "—"}</div>
        </div>
      );
    })}
  </div>
);

export const STATUS_TONE = {
  pending: "gold", resident_submitted: "gold", staff_assessed: "green",
  assigned: "dim", pending_resident_response: "gold", awaiting_verification: "gold",
  verified: "green", flagged: "red", waived: "dim", overdue: "red",
};
